import { PeriodFilter, TypeFilter } from '../service/filters.interface';
import {
    FilterOption,
    PAGE_TYPE,
    PageType,
} from '../../../components/TabSwitcher/service/tabs.interface';

const ANALYTICS_TYPES: FilterOption<PageType>[] = [
    {
        value: 'all',
        label: 'Вся аналитика',
        slug: [PAGE_TYPE.MONITORING, PAGE_TYPE.MANAGE],
    },
    {
        value: 'moderation',
        label: 'Модерация',
        slug: [PAGE_TYPE.MANAGE],
    },
    {
        value: 'members',
        label: 'Участники',
        slug: [PAGE_TYPE.MONITORING, PAGE_TYPE.MANAGE],
    },
    {
        value: 'messages',
        label: 'Сообщения',
        slug: [PAGE_TYPE.MONITORING, PAGE_TYPE.MANAGE],
    },
    {
        value: 'finance',
        label: 'Финансы',
        slug: [PAGE_TYPE.MANAGE],
    },
] satisfies { value: TypeFilter; label: string; slug: PageType[] }[];

const ANALYTICS_PERIODS = [
    {
        value: 'day',
        label: 'За день',
    },
    {
        value: 'week',
        label: 'За неделю',
    },
    {
        value: 'month',
        label: 'За месяц',
    },
    {
        value: 'year',
        label: 'За год',
    },
    {
        value: 'period',
        label: 'За период',
    },
] satisfies { value: PeriodFilter; label: string }[];

const DOWNLOAD_ACTIONS = [
    {
        value: 'download',
        label: 'Скачать',
    },
] satisfies { value: string; label: string }[];

export default {
    ANALYTICS_TYPES,
    ANALYTICS_PERIODS,
    DOWNLOAD_ACTIONS,
};

export const items = [
    {
        key: '1',
        label: 'Скачать в CSV',
    },
];
